import ApiClient from '../../../../api/ApiClient';

class SchedulingAPI extends ApiClient {
  constructor() {
    super('scheduling', { accountScoped: true });
  }

  // Grade Semanal Fixa de Vagas
  getFixedGrid(params = {}) {
    return window.axios.get(`${this.url}/fixed_grid`, { params });
  }

  // Matrículas / Alunos Fixos
  getEnrollments(params = {}) {
    return window.axios.get(`${this.url}/enrollments`, { params });
  }
  getEnrollment(id) {
    return window.axios.get(`${this.url}/enrollments/${id}`);
  }
  createEnrollment(data) {
    return window.axios.post(`${this.url}/enrollments`, { enrollment: data });
  }
  updateEnrollment(id, data) {
    return window.axios.put(`${this.url}/enrollments/${id}`, { enrollment: data });
  }
  checkInEnrollment(id, data = {}) {
    return window.axios.post(`${this.url}/enrollments/${id}/check_in`, data);
  }
  renewEnrollment(id, data = {}) {
    return window.axios.post(`${this.url}/enrollments/${id}/renew`, data);
  }
  rescheduleEnrollment(id, data = {}) {
    return window.axios.post(`${this.url}/enrollments/${id}/reschedule`, data);
  }
  grantReplacementCredit(id, data = {}) {
    return window.axios.post(`${this.url}/enrollments/${id}/grant_replacement`, data);
  }
  renewMonthlyCycle(id, data = {}) {
    return window.axios.post(`${this.url}/enrollments/${id}/renew_monthly_cycle`, data);
  }
  deleteEnrollment(id) {
    return window.axios.delete(`${this.url}/enrollments/${id}`);
  }

  // Atendimentos / Prontuário Clínico
  updateAttendance(id, data = {}) {
    return window.axios.put(`${this.url}/attendances/${id}`, { attendance: data });
  }
  deleteAttendance(id) {
    return window.axios.delete(`${this.url}/attendances/${id}`);
  }

  // Reposições / Remarcações
  getReschedulings() {
    return window.axios.get(`${this.url}/reschedulings`);
  }
  deleteRescheduling(id) {
    return window.axios.delete(`${this.url}/reschedulings/${id}`);
  }

  // Serviços
  getServices() {
    return window.axios.get(`${this.url}/services`);
  }
  createService(data) {
    return window.axios.post(`${this.url}/services`, { service: data });
  }
  updateService(id, data) {
    return window.axios.put(`${this.url}/services/${id}`, { service: data });
  }
  deleteService(id) {
    return window.axios.delete(`${this.url}/services/${id}`);
  }

  // Profissionais
  getProfessionals() {
    return window.axios.get(`${this.url}/professionals`);
  }
  createProfessional(data) {
    return window.axios.post(`${this.url}/professionals`, { professional: data });
  }
  updateProfessional(id, data) {
    return window.axios.put(`${this.url}/professionals/${id}`, { professional: data });
  }
  deleteProfessional(id) {
    return window.axios.delete(`${this.url}/professionals/${id}`);
  }

  // Pacientes
  getPatients(params = {}) {
    return window.axios.get(`${this.url}/patients`, { params });
  }
  getPatient(id) {
    return window.axios.get(`${this.url}/patients/${id}`);
  }
  lookupPatientForContact(contactId) {
    return window.axios.get(`${this.url}/patients/lookup_for_contact`, { params: { contact_id: contactId } });
  }
  addSecondaryContact(patientId, data) {
    return window.axios.post(`${this.url}/patients/${patientId}/add_secondary_contact`, data);
  }
  removeSecondaryContact(patientId, phone) {
    return window.axios.post(`${this.url}/patients/${patientId}/remove_secondary_contact`, { phone });
  }
  linkPatientContact(patientId, contactId) {
    return window.axios.post(`${this.url}/patients/${patientId}/link_contact`, { contact_id: contactId });
  }
  createPatient(data) {
    return window.axios.post(`${this.url}/patients`, { patient: data });
  }
  updatePatient(id, data) {
    return window.axios.put(`${this.url}/patients/${id}`, { patient: data });
  }
  dischargePatient(id, data = {}) {
    return window.axios.post(`${this.url}/patients/${id}/discharge`, data);
  }
  reopenPatient(id) {
    return window.axios.post(`${this.url}/patients/${id}/reopen`);
  }
  blockPatient(id, data = {}) {
    return window.axios.post(`${this.url}/patients/${id}/block`, data);
  }
  unblockPatient(id) {
    return window.axios.post(`${this.url}/patients/${id}/unblock`);
  }
  deletePatient(id) {
    return window.axios.delete(`${this.url}/patients/${id}`);
  }

  // Parceiros
  getPartners() {
    return window.axios.get(`${this.url}/partners`);
  }
  createPartner(data) {
    return window.axios.post(`${this.url}/partners`, { partner: data });
  }
  updatePartner(id, data) {
    return window.axios.put(`${this.url}/partners/${id}`, { partner: data });
  }
  deletePartner(id) {
    return window.axios.delete(`${this.url}/partners/${id}`);
  }

  // Agendamentos (Tradicional / Histórico)
  getAppointments(params = {}) {
    return window.axios.get(`${this.url}/appointments`, { params });
  }
  createAppointment(data) {
    return window.axios.post(`${this.url}/appointments`, { appointment: data });
  }
  updateAppointment(id, data) {
    return window.axios.put(`${this.url}/appointments/${id}`, { appointment: data });
  }
  updateAppointmentStatus(id, status) {
    return window.axios.patch(`${this.url}/appointments/${id}/update_status`, { status });
  }
  updateAppointmentProntuario(id, prontuario_notes) {
    return window.axios.patch(`${this.url}/appointments/${id}/update_prontuario`, { prontuario_notes });
  }
  reschedulePackage(id, data = {}) {
    return window.axios.post(`${this.url}/appointments/${id}/reschedule_package`, { reschedule: data });
  }
  deleteAppointment(id) {
    return window.axios.delete(`${this.url}/appointments/${id}`);
  }

  // Horários Livres (para Agendamento e IA)
  getAvailableSlots(params = {}) {
    return window.axios.get(`${this.url}/available_slots`, { params });
  }
  getMonthOverview(params = {}) {
    return window.axios.get(`${this.url}/available_slots/month_overview`, { params });
  }

  // Configurações & Integrações (Notion, Webhooks IA)
  getSettings() {
    return window.axios.get(`${this.url}/settings`);
  }
  updateSettings(data) {
    return window.axios.put(`${this.url}/settings`, { setting: data });
  }
  testWebhook(data) {
    return window.axios.post(`${this.url}/settings/test_webhook`, data);
  }
  testNotion(data) {
    return window.axios.post(`${this.url}/settings/test_notion`, data);
  }

  // Relatórios
  getReports(params = {}) {
    return window.axios.get(`${this.url}/reports`, { params });
  }

  // Portal do Profissional (Auth & Web App)
  portalLogin(email, password) {
    return window.axios.post('/api/v1/scheduling/portal/login', { email, password });
  }
  portalGetMe(token) {
    return window.axios.get('/api/v1/scheduling/portal/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalGetAgenda(token, date) {
    return window.axios.get('/api/v1/scheduling/portal/agenda', {
      params: { date },
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalRecordAttendance(token, data) {
    return window.axios.post('/api/v1/scheduling/portal/attendances', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalUpdateAttendance(token, id, data) {
    return window.axios.put(`/api/v1/scheduling/portal/attendances/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalReschedule(token, data) {
    return window.axios.post('/api/v1/scheduling/portal/reschedule', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalGetPatients(token) {
    return window.axios.get('/api/v1/scheduling/portal/patients', {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalGetPatientDetails(token, id) {
    return window.axios.get(`/api/v1/scheduling/portal/patients/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalGetTimeBlocks(token) {
    return window.axios.get('/api/v1/scheduling/portal/time_blocks', {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalCreateTimeBlock(token, data) {
    return window.axios.post('/api/v1/scheduling/portal/time_blocks', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalDeleteTimeBlock(token, id) {
    return window.axios.delete(`/api/v1/scheduling/portal/time_blocks/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalChangePassword(token, data) {
    return window.axios.post('/api/v1/scheduling/portal/change_password', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  portalForgotPassword(login) {
    return window.axios.post('/api/v1/scheduling/portal/forgot_password', { login });
  }
}

export default new SchedulingAPI();
